export default __webpack_public_path__ + "static/media/network-off.3850ef10.svg";